$(function(){
  try {
    sessionStorage.removeItem('FreeGift');
  } catch (err) {}
  cartJSEvent();
  masterPromo(false);
  calculateProgress();
  calculateProgressGWP();
  jscInitGiftCardRestriction();
 // collectionSortBy();
  if (location.href.includes('/products')) {
    initFlickityImageGallery();
    onloadSiblingsProducts();
    onloadPDPbutton();
  }
  if (location.href.includes('/collection')) {
    stickyFilter();
  }
  initAnnouncementSlider();
  initLogoListSlider();
});

//start: hover grid
jscHoverGrid = (e) => {
  if ($(window).width() > 799) {
    $(e).find('.jsc-grid-size-container').removeClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-prev-arrow').removeClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-next-arrow').removeClass('d-none');
    
  }
}
jscOuthoverGrid = (e) => {
  if ($(window).width() > 799) {
    $(e).find('.jsc-grid-size-container').addClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-prev-arrow').addClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-next-arrow').addClass('d-none');
    
  }
}
//end: hover grid

//start: shorten product title
onloadShortenProdTitle = () => {
  if ($(window).width() < 380) {
    var maxCharacters = 16;
  }
  else if ($(window).width() < 480) {
    var maxCharacters = 23;
  }
   else if ($(window).width() < 798) {
    var maxCharacters = 42;
   }
   else if ($(window).width() < 1025) {
    var maxCharacters = 24;
   }
   else if ($(window).width() > 1026) {
    var maxCharacters = 38;
   } else {
    var maxCharacters = 30;
  }
  
  $(document).ready(function() {
    $(".product__grid-item").each(function() {
      var productTitle = $(this).find(".product-thumbnail__title");
      var originalText = productTitle.text();
  
      var maxTitleWidth = $(this).width(); // Get the grid container width
      var fontSize = parseFloat(productTitle.css("font-size"));
      // var maxCharacters = Math.floor(maxTitleWidth / fontSize);
      // var maxCharacters = Math.floor(maxTitleWidth / 10);
      
      console.log(maxTitleWidth,fontSize,maxCharacters);
      if (originalText.length > maxCharacters) {
        var truncatedText = originalText.substring(0, maxCharacters) + "...";
        productTitle.text(truncatedText);
      }
    });
  });
}
//end: shorten product title

//start: collection filter
jscShowDrawer = (e) => {
  $('.jsc-filter-drawer-container').addClass('show-drawer');  
  $('html').addClass('drawer-open');
  
}
jscHideDrawer = (e) => {
  $('.jsc-filter-drawer-container').removeClass('show-drawer');
  $('html').removeClass('drawer-open');
}
//end: collection filter

//start: change grid layout in mobile
jscMobileGridLayout = (e,grid) => {

  var grids = $(e).parents('.collection-main').find('.collection__content .product__grid-item');

  if (grid == 'layout-switch--one-column') {
    grids.removeClass('small-down--one-half');
    grids.addClass('small-down--one-whole');
    // console.log('show 1 grids');
  }
  else if (grid == 'layout-switch--two-columns') {
    grids.addClass('small-down--one-half');
    grids.removeClass('small-down--one-whole');
    // console.log('show 2 grids');
  } else {

  }

  $(e).addClass('layout-switch--active');
  $(e).siblings('.layout-switch').removeClass('layout-switch--active');
   
}
//end: change grid layout in mobile

//start: to change the Sort By dropdown width
collectionSortBy = () => {
  // console.log('find dropdown',$("#sort-by").length);
  var url = window.location.href;
  console.log('url',url);
  var dropdown_width = $('#sort-by option:selected').width();
  console.log('current dropdown width',dropdown_width,'hidden dropdown width',$("#width_tmp_select").width());
  
  setTimeout(function(){
    
    
  }),3000;
  // $('#sort-by').width($("#width_tmp_select").width() + 15);
  // $(document).ready(function() {
  //   $("#width_tmp_option").html($('#sort-by option:selected').text());
  //   $('#sort-by').width($("#width_tmp_select").width());

  //   $('#sort-by').change(function(){
  //     $("#width_tmp_option").html($('#sort-by option:selected').text());
  //     $(this).width($("#width_tmp_select").width() + 15);
  //     console.log('click here');
  //   });
  // });
}
//end: to change the Sort By dropdown width

//start: update pdp ATC button
onloadPDPbutton = () => {
  var $oosBtn = $('.jsc-pdp-atc-btn-container.jsc-oos-button');
  var $oosBtnInner = $('.jsc-pdp-atc-btn-container.jsc-oos-button .button--add-to-cart');
  if ($oosBtn.length > 0) {
    $('.jsc-pdp-atc-btn-container.jsc-oos-button .button--add-to-cart .text').text('Notify Me');
    console.log('variant oos');

    var timer = setInterval(function() {
      var $wishlistBtn = $('.jsc-pdp-atc-btn-container .swym-button-bar');
      var $klaviyoBtn = $('.jsc-pdp-atc-btn-container .klaviyo-bis-trigger')
  
      if ($wishlistBtn.length > 0) {
        if ($klaviyoBtn.length > 0 ) {
          $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger').removeClass('d-none');
          $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger').css({
            'display': 'block'
          });
          // setTimeout(function(){
            $oosBtnInner.css({
              // 'color': 'transparent',
              'position': 'absolute',
              'z-index': '-1'
            });
          // },100);
          
          clearInterval(timer);
        }
      }
    })
  }
  
}
//end: update pdp ATC button

//start: to update button style in PDP
jscSelectVariant = (e,size,var_avail,var_id) => {
  // var $label = $(e).parents('.variant-wrapper').find('.jsc-pdp-size');
  // $label.find('.jsc-selected-variant').text(size);
  console.log(size,var_avail,var_id);

  if (var_avail == 'true') {
    $('.jsc-pdp-atc-btn-container').removeClass('jsc-oos-button');
    $('.jsc-pdp-atc-btn-container').find('.jsc-atc-text').text('Add to cart');
    $('.jsc-pdp-atc-btn-container .button--add-to-cart').css({
      'position': 'relative',
      'z-index': 'auto'
    });
  } else {
    $('.jsc-pdp-atc-btn-container').addClass('jsc-oos-button');
    $('.jsc-pdp-atc-btn-container').find('.jsc-atc-text').text('Notify Me');
    $('.jsc-pdp-atc-btn-container.jsc-oos-button .button--add-to-cart').css({
      'position': 'absolute',
      'z-index': '-1'
    });
    $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger').removeClass('d-none');
  }

  //start: price snippet
  var variant_info = $('.jsc-all-variants-info');

  if (variant_info.length > 0) {
    variant_info.children().each(function(){
      var $varID = $(this).attr('data-var-id');

      if ($varID == var_id) {
        $(this).removeClass('d-none');
        $(this).addClass('d-flex');
      } else {
        $(this).addClass('d-none');
        $(this).removeClass('d-flex');
      }
      
    });
  }
  //end: price snippet
}
//end: to update button style in PDP

//start: initiate flickity for image gallery in pdp
initFlickityImageGallery = () => {
  var $newGallery = $('.jsc-product-gallery__main').length;

  if ($(window).width() < 798) {
    if ($newGallery > 0) {
      console.log('init flickity in mobile');
      $('.jsc-product-gallery__main').flickity({
        // options
        prevNextButtons : false,
        pageDots : true,
        wrapAround : true,
        contain: true,
        cellAlign: 'left',
        draggable: true,
        imagesLoaded : true,
        on: {
          ready: function() {
            $(this.element).addClass('jsc-flickity-initiated');
          }
        }
      });
    }
  }

  // setTimeout(function(){
  //   var $gallery = $('.jsc-product-gallery__main.flickity-enabled').length;
  //   console.log('default flick image gallery',$gallery,$(window).width());
  // },1500);
  
}
//end: initiate flickity for image gallery in pdp

//start: color siblings feature in pdp
onloadSiblingsProducts = () => {
  var $prod_details = $('.jsc-prod-json-details').find('.jsc-each-prod-json');
  var $prod_sibs_container = $('.jsc-sibling-products-content');
  var $prod_sibs_grid = $prod_sibs_container.find('.jsc-each-colour-url');
  var $current_url = window.location.href;

  $prod_details.each(function(){
    var $this_graphql = $(this).attr('data-graphql');
    
        // Define your GraphQL query
        const graphqlQuery = `
        query {
          product(id: "` + $this_graphql + `") {
            id
            title
            handle
            variants(first: 10) {
              edges {
                node {
                  title
                }
              }
            }
            featuredImage {
              id
              src
            }
          }
        }
        `;
        
        // Set the endpoint URL
        const endpointUrl = 'https://edgeclothing.myshopify.com/api/2023-10/graphql.json';

        // Send the GraphQL request using jQuery
        $.ajax({
          url: endpointUrl,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '21eb93fc41c98da6f7c14eb991237105' , 
          },
          data: JSON.stringify({ query: graphqlQuery }),
          success: function(response) {
            // Handle the response here
            console.log('Result',response);
            var prod_title = response.data.product.title;
            var prod_handle = response.data.product.handle;
            var prod_img = response.data.product.featuredImage.src;
            var prod_url = '/products/' + prod_handle;
            var variant_title = response.data.product.variants.edges[0].node.title;
            var variant_color = variant_title.split(" / ");
            var type_tab;
            var var_color = '';

            if (variant_color[0] !== undefined ) {
              var_color = variant_color[0];
            } else {
              var_color = '';
            }
            var color_handle = var_color.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

            if ($current_url.includes(color_handle) && var_color != '') {
              type_tab = 'jsc-active-col';
            } else {
              type_tab = 'jsc-inactive-col';
            }
            
            var $color_grid = '<a href="' + prod_url + '" class="jsc-each-colour-url"><div class="jsc-each-colour-prod ' + type_tab + '"><img class="jsc-each-colour-prod-img" src="' + prod_img + '" alt="' + prod_title +'"></div><span>' + var_color + '</span></a>';

            $prod_sibs_grid.each(function(){
              var $thisGraphql = $(this).attr('data-graphql');
              var $thisUrl;
              var $thisColor = $(this).find('span');
              var $thisColorImg = $(this).find('.jsc-each-colour-prod-img');             

              if ($thisGraphql == $this_graphql) {
                $thisUrl = $(this).attr("href",prod_url);
                $thisColor.text(var_color);
                $thisColorImg.attr("src",prod_img);
                $thisColorImg.attr("alt",prod_title);
                
                $(this).addClass(type_tab);
                $(this).removeClass('d-none');
                
              }
            });
          },
          error: function(error) {
            // Handle any errors here
            console.error('Error!',error);
          }
        });
  });

}
//end: color siblings feature in pdp

//start: make collection filter sticky when scrolling
stickyFilter = () => {
  
  $(window).scroll(function() {
    var $stickynav = $('.header-sticky-wrapper').length;
    // console.log('$stickynav',$stickynav,$(document).scrollTop());

    if ($(document).scrollTop() > 80) {

      if ($stickynav > 0) {
        // if the menu nav is sticky, make the collection filter sticky after the menu nav
        $(".jsc-collection-header-section").addClass("jsc-filter-sticky");
      } else { 
        // if the menu nav is not sticky, make the collection filter stick to top
        $(".jsc-collection-header-section").addClass("jsc-filter-sticky-top");
      }
      
      // console.log('sticky collection filter');
    } else {
      $(".jsc-collection-header-section").removeClass("jsc-filter-sticky-top");
      $(".jsc-collection-header-section").removeClass("jsc-filter-sticky");
      // console.log('unstick collection filter');
    }
  });
}

//start: pdp size guide popup
jscDisablePageScroll = (e,check) => {

  if (check == 'true') {
    $(e).parents('body').addClass('modal-open');
  } else {
    $(e).parents('body').removeClass('modal-open');
  }
  
}
//end: pdp size guide popup

//start: open first level nav as slider
jscOpenMenu = (e,title) => {
  var $selectedNav = $(e).parents('.mobile-menu__list-item');
  $selectedNav.addClass('menu-opening');

  // console.log('open',title);
  
}
jscCloseMenu = (e,title) => {
  var $selectedNav = $(e).parents('.mobile-menu__list-item');

  setTimeout(function(){
    $selectedNav.find('.close-dropdown').trigger( "click" );
    $selectedNav.removeClass('menu-opening');
  },200);
  
}
//end: open first level nav as slider

//start: zoom image when click on the zoom icon
zoomImagePdp = (e) => {
  
  if ($(window).width() > 799) {
    var $imgGallery = $(e).siblings('.jsc-product-gallery__main').find('.product-gallery__image');
    var $imgFirst = $imgGallery.first(); //get only the first image for desktop

  } else {
    var $imgFirst = $(e).siblings('.jsc-product-gallery__main').find('.product-gallery__image.is-selected'); // get the active image for mobile

  }
  // console.log('$imgFirst',$imgFirst);

  $imgFirst.find('.product-gallery__link').click(); //click only the first image for desktop. click on the active image for mobile
  
}
//end: zoom image when click on the zoom icon

// START Free shipping delivery
// Calculate the progress number, and the width of the progress bar.
function calculateProgress(currentVal, targetVal) {

  var freeDeliverySection = $('.jsc-cart-freedelivery__wrapper')
  var cartMinText = freeDeliverySection.find('.cart-shipping__wrapper').attr('minprice-aud');
  var cartMinVal = parseInt(cartMinText);
  var progressBar = $('.cart-shippingThreshold__progress');
  var progressNum = $('.cart-shipping__num');
  var progressOuter = $('.cart-shipping__numOuter');
  var successMsg = $('.cart-shipping__success');
  var $cartBars = $(
    '.jsc-cart-drawer-div .jsc-cart-freedelivery-section, .jsc-cartpage-shipping-gwp-section .jsc-cart-freedelivery-section'
  );

  $.when($.getJSON('/cart.js', function(cart) {
    var hideCartBars = typeof jscExcludeGiftcardFromFreeDelivery === 'function' &&
      jscExcludeGiftcardFromFreeDelivery() &&
      typeof jscCartContainsGiftCard === 'function' &&
      jscCartContainsGiftCard(cart);
    var _totalPrice = typeof jscGetFreeDeliveryEligibleTotal === 'function'
      ? jscGetFreeDeliveryEligibleTotal(cart)
      : cart.total_price;
    var $visibleBars = freeDeliverySection;

    if (hideCartBars) {
      $cartBars.addClass('d-none');
      $visibleBars = freeDeliverySection.not($cartBars);
      progressBar = $visibleBars.find('.cart-shippingThreshold__progress');
      progressNum = $visibleBars.find('.cart-shipping__num');
      progressOuter = $visibleBars.find('.cart-shipping__numOuter');
      successMsg = $visibleBars.find('.cart-shipping__success');
    }
    
    if (_totalPrice > 0 && $visibleBars.length) {
      $visibleBars.removeClass('d-none');
      var calcFreeDeliveryVal = (cartMinVal - _totalPrice) / 100;
      var progressWidth = Math.round(100 * _totalPrice / cartMinVal);
      if (progressWidth >= 100) {
        progressWidth = 100;
      }
      var progressWidthPercent = progressWidth.toString() + '%';
      console.log('cart Total',_totalPrice,cartMinVal,progressWidth,progressWidthPercent);

      progressBar.each(function(){
        
        $(this).css({
          width: progressWidthPercent
        });
      });

      if (_totalPrice >= cartMinVal) {
        console.log('free delivery');
        progressOuter.hide();
        successMsg.show();
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      } else {
        console.log('still short from free delivery',calcFreeDeliveryVal);
        progressNum.text(calcFreeDeliveryVal);
        progressOuter.show();
        successMsg.hide();
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      }
    }
    else{
      console.log('cart Total',_totalPrice);
      if (hideCartBars) {
        $cartBars.addClass('d-none');
      } else {
        $('.jsc-cart-freedelivery__wrapper').addClass('d-none');
      }
    }
    
  })).then(function() {
    
  });

};

// In your theme's main JS file, find each ajax call where your store adds to, deletes from, and updates the cart. Put this in the success function of each. 
// NOTE: If you make this ajax request outside of the functions that update the cart, the calculator won't sync with the current cart state without refreshing the page. You need to specify that you want to read the current cart data AFTER the new items are added/removed.
 fetch('/cart.js')
.then(response => response.json())
.then(data => {
  var _sgMinPrice = parseInt($('.cart-shipping__wrapper').attr('minprice-sgd'));
  calculateProgress(data.total_price, _sgMinPrice);
});

jscRecalculateProgress = () => {
  setTimeout(function(){
    calculateProgress();
    // console.log('recalculate');
  },500);
}
// END Free shipping delivery

//start: close cart drawer
jscCloseCartDrawer = () => {
  $('.ajax-cart__close-icon').click();
}
//end: close cart drawer

// start: announcement bar slider
initAnnouncementSlider = () => {
  var slider = $('.announcement-bar__container .announcement-bar__content');
  var isAutoplay = $(slider).attr('data-is-autoplay');
  var duration = parseInt($(slider).attr('data-duration')) * 1000;

  if(isAutoplay == 'true') {
    $(slider).flickity({
      prevNextButtons : false,
      pageDots : false,
      wrapAround : true,
      contain: true,
      cellAlign: 'center',
      draggable: true,
      autoPlay: duration,
      pauseAutoPlayOnHover: true
    });
  }
  else {
    $(slider).flickity({
      prevNextButtons : false,
      pageDots : false,
      wrapAround : true,
      contain: true,
      cellAlign: 'center',
      draggable: true
    });
  }
}
// end: announcement bar slider

// start: logo list slider
initLogoListSlider = () => {
  var slider = $('.jsc-scrollable-logo-section .logo_slider');
  var duration = 2500;
  
  var slider_number = $('.jsc-scrollable-logo-section').attr('data-grid-number');
  //var group_cells = parseInt(slider_number);
  

  if($(window).width() < 798 ) {
    //group_cells = 2;
  }
  else if ($(window).width() < 480 ) {

  }

  if ($('.jsc-scrollable-logo-section').length > 0) {
    $(slider).flickity({
      prevNextButtons : true,
      pageDots : false,
      wrapAround : true,
      contain: true,
      cellAlign: 'left',
      draggable: true,
      autoPlay: duration,
      pauseAutoPlayOnHover: false
    });
  }

}

// Foxwood parity: GC lines never keep +/- steppers — replace with a static "1".
jscApplyCartDrawerGiftCardFixedQuantity = ($lineItem, itemQty) => {
  if (!$lineItem || !$lineItem.length) return;

  var $selector = $lineItem.find('.jsc-qty-selector.cart-line-item-qty').first();
  if (!$selector.length) {
    $selector = $lineItem.find('.jsc-qty-selector').first();
  }
  if (!$selector.length) return;

  // Restriction rule is max 1 GC unit — always display 1 (same as Foxwood).
  var qty = 1;
  var parsed = parseInt(itemQty, 10);
  if (!isNaN(parsed) && parsed > 0) {
    qty = parsed;
  }

  $lineItem.attr('data-is-gift-card', 'true');
  $selector.removeClass('jsc-cart-drawer-free-gift-label');
  $selector.find('.jsc-cart-drawer-free-gift-span').remove();
  $selector.find('.quantity').remove();

  var $fixed = $selector.find('.jsc-cart-drawer-gwp-fixed-qty');
  if ($fixed.length) {
    $fixed.text(String(qty));
  } else {
    $selector.append('<span class="jsc-cart-drawer-gwp-fixed-qty">' + qty + '</span>');
  }
};

// After SSR / AJAX, mark GC lines from live cart.js so Liquid detection gaps don't bring steppers back.
jscStampGiftCardDrawerLinesFromCart = (cart) => {
  if (!jscGiftCardRestrictionEnabled() || !cart || !Array.isArray(cart.items)) return;

  cart.items.forEach(function(item) {
    if (!jscIsGiftCardCartItem(item)) return;

    jscRememberGiftCardProductId(item.product_id);

    var selectors = [];
    if (item.key) {
      selectors.push('.jsc-cart-line-items[data-key="' + item.key + '"]');
    }
    if (item.id) {
      selectors.push('.jsc-cart-line-items[data-var-id="' + item.id + '"]');
    }
    if (!selectors.length) return;

    $(selectors.join(',')).each(function() {
      var $line = $(this);
      if ($line.hasClass('jsc-dummy-cart-line-items')) return;
      if ($line.attr('data-gwp') === 'true') return;
      if (item.product_id) {
        $line.attr('data-product-id', item.product_id);
      }
      jscApplyCartDrawerGiftCardFixedQuantity($line, item.quantity);
    });
  });
};

updateCartDrawerGiftState = ($lineItem, isGiftItem, itemQty, promoNo) => {
  if (!$lineItem || !$lineItem.length) {
    return;
  }

  var $selector = $lineItem.find('.jsc-qty-selector');

  if (!$selector.length) {
    return;
  }

  var isGiftCardLocked =
    typeof jscGiftCardRestrictionEnabled === 'function' &&
    jscGiftCardRestrictionEnabled() &&
    $lineItem.attr('data-is-gift-card') === 'true';

  if (isGiftItem) {
    $selector.removeClass('jsc-cart-drawer-free-gift-label');
    $selector.find('.jsc-cart-drawer-free-gift-span').remove();
    $selector.find('.quantity').remove();
    var $fixedQty = $selector.find('.jsc-cart-drawer-gwp-fixed-qty');
    if ($fixedQty.length) {
      $fixedQty.text('1');
    } else {
      $selector.append('<span class="jsc-cart-drawer-gwp-fixed-qty">1</span>');
    }
    $lineItem.attr('data-gwp','true');
    $lineItem.attr('data-promo', jscNormalizeGwpPromo(promoNo));
  } else if (isGiftCardLocked) {
    $lineItem.attr('data-gwp','false');
    $lineItem.removeAttr('data-promo');
    jscApplyCartDrawerGiftCardFixedQuantity($lineItem, itemQty);
  } else {
    $selector.find('.jsc-cart-drawer-gwp-fixed-qty').remove();
    if (!$selector.find('.quantity').length) {
      var $templateSelector = $('.jsc-dummy-cart-line-items .jsc-qty-selector').first().clone(true, true);
      $selector.replaceWith($templateSelector);
      $selector = $lineItem.find('.jsc-qty-selector');
    }

    $selector.removeClass('jsc-cart-drawer-free-gift-label');
    $selector.find('.jsc-cart-drawer-free-gift-span').remove();
    $lineItem.attr('data-gwp','false');
    $lineItem.removeAttr('data-promo');

    var $input = $selector.find('.cart-item__quantity-input');
    if ($input.length) {
      $input.val(itemQty);
      $input.attr('value', itemQty);
      $input.attr('data-committed-qty', itemQty);
    }

    var $inputForMax = $selector.find('.cart-item__quantity-input');
    var maxQty = NaN;
    if (typeof jscGetCartDrawerQtyMax === 'function' && $inputForMax.length) {
      maxQty = jscGetCartDrawerQtyMax($inputForMax, $lineItem);
    }
    if (typeof jscSyncCartDrawerQtyControls === 'function' && $inputForMax.length) {
      jscSyncCartDrawerQtyControls($inputForMax, parseInt(itemQty, 10) || 1, maxQty);
    } else {
      var $minusBtn = $selector.find('.minus');
      var $plusBtn = $selector.find('.plus');
      if ($minusBtn.length) {
        if (itemQty > 1) {
          $minusBtn.removeClass('unusable');
        } else {
          $minusBtn.addClass('unusable');
        }
      }
      if ($plusBtn.length) {
        if (!isNaN(maxQty) && itemQty >= maxQty) {
          $plusBtn.addClass('unusable');
        } else {
          $plusBtn.removeClass('unusable');
        }
      }
    }
  }
}
// end: logo list slider

jscRedirectToCart = () => {
  cartUrl = '/cart';
  window.location.href = cartUrl;
}

// In-memory GWP opt-out (Eve-style): blocks re-add only until the next cart change or page refresh
var jscGwpOptOut = {};
var jscGwpOptOutPending = false;

jscNormalizeGwpPromo = (promo) => {
  if (promo != null && String(promo) !== '') {
    return String(promo);
  }
  return '1';
};

jscSetGwpOptOut = (promo) => {
  jscGwpOptOut[jscNormalizeGwpPromo(promo)] = true;
  jscGwpOptOutPending = true;
};

// Eve-style: keep opt-out for the remove's own completion; clear on later cart changes
jscClearGwpOptOutAfterCartChange = () => {
  if (jscGwpOptOutPending) {
    jscGwpOptOutPending = false;
  } else {
    jscGwpOptOut = {};
  }
};

// Always clear opt-out (safe for non-CartJS paths like PDP fetch ATC, which are never the gift-remove completion)
jscAllowGwpReadd = () => {
  jscGwpOptOut = {};
  jscGwpOptOutPending = false;
};

//Start CartJS Function
cartJSEvent = () => {
  $(document).on('cart.requestComplete', function(event, cart) {
    console.log('cart updated');

    jscClearGwpOptOutAfterCartChange();

    refreshCartGiftMarkup();
    if (location.href.includes('/cart')) {
      // AJAX refresh keeps in-memory opt-out (full reload would wipe it and re-add GWP)
      $(".jsc-cart-container").load(location.href + " .jsc-cart-container>*", "");
    }
    document.documentElement.dispatchEvent(
    new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
    $('.jsc-page-loading').remove();
    var varID = $('.variant-selection').attr('variant');
    //jscUpdateCartDrawer(varID);

    if (cart) {
      jscSyncGiftCardRestrictionFromCart(cart);
    }

    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      jscSyncGiftCardRestrictionFromCart(data);
      var $cartQty = data.item_count;
      var $cart_icon = $('.header-cart__count').parents('.header-cart');
      //console.log('cart count',$cartQty);
      if ($cartQty >= 1 && !$cart_icon.hasClass('has-cart-count')) {
        $cart_icon.addClass('has-cart-count');
      }
      if ($cartQty == 0 && $cart_icon.hasClass('has-cart-count')) {
        $cart_icon.removeClass('has-cart-count');
      }
    });
  });
  $(document).on('cart.requestStarted', function(event, cart) {
    if (location.href.includes('/cart')) {
      var $html = `<div class="jsc-page-loading">
                  <div class="jsc-spinner-container">
                    <div class="jsc-loading-text">Updating your cart...</div>
                  </div>
                </div>`;
      $('body').prepend($html);
    }
    console.log('updating cart');
  });
}

cartJSAddQuery = (vid, qty, obj, isOpenDrawer) => {
  // Cart js add item, success callback, error callback

  return new Promise((resolve, reject) => {
    CartJS.addItem(vid, qty, obj, {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        if (typeof refreshCartGiftMarkup === 'function') {
          refreshCartGiftMarkup();
        }
        if (typeof jscUpdateCartDrawer === 'function' && isOpenDrawer) {
          jscUpdateCartDrawer(vid, false);
        }
        resolve(data);
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
        reject(errorThrown);
      }
    });
  });
}

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer, meta) => {
  // Cart js add item, success callback, error callback

  meta = meta || {};
  var identifier = vid;
  var isStringIdentifier = typeof identifier === 'string';
  var isNumberIdentifier = typeof identifier === 'number';
  var isNumericString = isStringIdentifier && /^\d+$/.test(identifier);
  var useVariantId = isNumberIdentifier || isNumericString;
  var numericIdentifier = useVariantId ? parseInt(identifier, 10) : null;
  var giftVariantId = meta.giftVariantId ? parseInt(meta.giftVariantId, 10) : null;
  var isGiftRemoval = !!meta.isGiftRemoval;

  return new Promise((resolve, reject) => {
    var callbacks = {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {

        if (location.href.includes('/cart')) {
          //reload only the product details section in cart page
          if (!data.item_count) { // if cart is empty do this
            $(".jsc-cart-container").load(location.href+" .jsc-cart-container>*","");
          }
        }

        if (typeof refreshCartGiftMarkup === 'function') {
          refreshCartGiftMarkup();
        }

        var varIdForDrawer = useVariantId ? numericIdentifier : '';
        var drawerGiftIndicator = false;

        if (isGiftRemoval || (!useVariantId && qty === 0)) {
          drawerGiftIndicator = giftVariantId || true;
        }

        if (typeof jscUpdateCartDrawer === 'function' && isOpenDrawer) {
          jscUpdateCartDrawer(varIdForDrawer, drawerGiftIndicator);
        }

        resolve(data);
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
        reject(errorThrown);
      }
    };

    if (!useVariantId) {
      CartJS.updateItem(identifier, qty, obj, callbacks);
    } else {
      CartJS.updateItemById(numericIdentifier, qty, obj, callbacks);
    }
  });
}
//End CartJS Function

//Start Master Promo Function
masterPromo = (isDrawer) =>{
  // setTimeout(function(){
  // },1000);
  cartGift();
}

//Start GWP based on cart, product or collection promo
cartGift = () =>{
  addCartGift();
  removeCartGift();
}

refreshCartGiftMarkup = (sectionIds) => {
  var $wrappers = $('[data-gwp-wrapper]');

  if (!$wrappers.length) {
    cartGift();
    return Promise.resolve();
  }

  var idsToFetch = [];

  if (Array.isArray(sectionIds) && sectionIds.length) {
    idsToFetch = sectionIds;
  } else {
    $wrappers.each(function(){
      var sectionId = $(this).data('section-id');

      if (sectionId && idsToFetch.indexOf(sectionId) === -1) {
        idsToFetch.push(sectionId);
      }
    });
  }

  if (!idsToFetch.length) {
    cartGift();
    return Promise.resolve();
  }

  var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  var requestUrl = rootUrl + '?sections=' + idsToFetch.join(',');

  return fetch(requestUrl, { credentials: 'same-origin' })
    .then(function(response){
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(function(sectionData){
      idsToFetch.forEach(function(id){
        var html = sectionData[id];

        if (!html) {
          return;
        }

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newWrapper = doc.querySelector('[data-gwp-wrapper][data-section-id="' + id + '"]');
        var targetWrapper = document.querySelector('[data-gwp-wrapper][data-section-id="' + id + '"]');

        if (newWrapper && targetWrapper) {
          targetWrapper.innerHTML = newWrapper.innerHTML;
        }
      });
    })
    .catch(function(error){
      console.error('Failed to refresh cart gift markup', error);
    })
    .finally(function(){
      cartGift();
    });
}

window.jscGwpState = window.jscGwpState || { adding: {}, removing: {} };

addCartGift = () =>{
  var $elem = $('.jsc-cart-gift');
  if (!$elem.length) {
    return;
  }

  if (jscShouldBlockGwpAutoAddForGiftCard()) {
    return;
  }

  var processedPromos = {};

  $elem.each(function(){
    var $this = $(this);
    var $vid = parseInt($this.val());
    var $promoNo = $this.attr('data-promo');

    if (!$promoNo || processedPromos[$promoNo]) {
      return;
    }

    processedPromos[$promoNo] = true;

    if (window.jscGwpState.adding[$promoNo]) {
      return;
    }

    if (jscGwpOptOut[jscNormalizeGwpPromo($promoNo)]) {
      return;
    }

    var addProperties = {
      '_Cart_Gift': $promoNo,
      '_Cart_GWP': 'Free Gift'
    };

    window.jscGwpState.adding[$promoNo] = true;
    console.log('add gwp');

    cartJSAddQuery($vid,1,addProperties,true)
      .catch(function(error){
        console.error('Failed to add gwp item', error);
      })
      .finally(function(){
        window.jscGwpState.adding[$promoNo] = false;
        $('.jsc-cart-gift').filter(function(){
          return $(this).attr('data-promo') == $promoNo;
        }).remove();
      });
  });
}

removeCartGift = () =>{
  var $elem = $('.jsc-cart-gift-remove');
  if (!$elem.length) {
    return;
  }

  var processedKeys = {};

  $elem.each(function(){
    var $this = $(this);
    var $key = $this.val();
    var $variantAttr = $this.attr('data-variant-id');
    var $variantId = $variantAttr ? parseInt($variantAttr, 10) : null;
    var identifier = (!isNaN($variantId) && $variantId) ? $variantId : $key;

    if (!$key || processedKeys[$key]) {
      return;
    }

    processedKeys[$key] = true;

    if (window.jscGwpState.removing[$key]) {
      return;
    }

    window.jscGwpState.removing[$key] = true;

    cartJSUpdateQuery(identifier, 0, {}, true, {
      isGiftRemoval: true,
      giftVariantId: $variantId,
      giftKey: $key
    })
      .then(function(){
        $('.jsc-cart-gift-remove').filter(function(){
          return $(this).val() == $key;
        }).remove();
      })
      .catch(function(error){
        console.error('Failed to remove gwp item', error);
      })
      .finally(function(){
        window.jscGwpState.removing[$key] = false;
      });
  });
}

removeFreeGift = (e, varID) => {
  // Cart-page GWP remove: Eve-style opt-out + CartJS line removal.
  // Gift can re-add after a later cart change or page refresh.
  var $lineItem = e ? $(e).closest('.cart__card, .jsc-cart-line-items') : $();
  var promo = $lineItem.length ? $lineItem.attr('data-promo') : null;
  jscSetGwpOptOut(promo);

  cartJSUpdateQuery(varID, 0, {}, true, {
    isGiftRemoval: true,
    giftVariantId: varID
  })
    .catch(function(error){
      console.error('Failed to remove gwp item via shortcut', error);
    });
}
//End GWP based on cart, product or collection promo

//start: gift card cart restriction
jscGiftCardRestrictionEnabled = () => {
  return !!(window.jscGiftCardRestriction && window.jscGiftCardRestriction.enabled);
};

jscEnsureGiftCardRestrictionState = () => {
  if (!window.jscGiftCardRestriction) {
    window.jscGiftCardRestriction = {
      enabled: false,
      removeRestrictionForGwp: false,
      excludeGiftcardFromFreeDelivery: false,
      cartHasGiftCard: false,
      cartHasNonGiftCard: false,
      giftCardQuantity: 0,
      checkoutBlocked: false,
      giftCardProductIds: [],
      disclaimerGcTemplate: '',
      disclaimerOtherTemplate: '',
      iconUrl: 'https://cdn.shopify.com/s/files/1/2153/3679/files/stageII_icon_6152952f-4a8b-4bb4-a9e4-2525f9670e17.png?v=1791772548'
    };
  }
  if (!Array.isArray(window.jscGiftCardRestriction.giftCardProductIds)) {
    window.jscGiftCardRestriction.giftCardProductIds = [];
  }
  if (typeof window.jscGiftCardRestriction.giftCardQuantity !== 'number') {
    window.jscGiftCardRestriction.giftCardQuantity = 0;
  }
  if (typeof window.jscGiftCardRestriction.checkoutBlocked !== 'boolean') {
    window.jscGiftCardRestriction.checkoutBlocked = false;
  }
  if (typeof window.jscGiftCardRestriction.removeRestrictionForGwp !== 'boolean') {
    window.jscGiftCardRestriction.removeRestrictionForGwp = false;
  }
  if (typeof window.jscGiftCardRestriction.excludeGiftcardFromFreeDelivery !== 'boolean') {
    window.jscGiftCardRestriction.excludeGiftcardFromFreeDelivery = false;
  }
  return window.jscGiftCardRestriction;
};

jscExcludeGiftcardFromFreeDelivery = () => {
  var state = jscEnsureGiftCardRestrictionState();
  return !!state.excludeGiftcardFromFreeDelivery;
};

jscGiftCardGwpExemptionEnabled = () => {
  var state = jscEnsureGiftCardRestrictionState();
  return !!state.removeRestrictionForGwp;
};

jscRememberGiftCardProductId = (productId) => {
  var state = jscEnsureGiftCardRestrictionState();
  var id = parseInt(productId, 10);
  if (!id || state.giftCardProductIds.indexOf(id) !== -1) return;
  state.giftCardProductIds.push(id);
};

jscIsGiftCardCartItem = (item) => {
  if (!item) return false;
  if (item.gift_card === true || item.gift_card === 'true') return true;

  var state = jscEnsureGiftCardRestrictionState();
  var productId = parseInt(item.product_id, 10);
  if (productId && state.giftCardProductIds.indexOf(productId) !== -1) return true;

  var handle = String(item.handle || '').toLowerCase();
  if (handle.indexOf('gift-card') !== -1 || handle.indexOf('gift_card') !== -1 || handle.indexOf('giftcard') !== -1) {
    return true;
  }

  var productType = String(item.product_type || '').toLowerCase();
  if (productType.indexOf('gift card') !== -1 || productType.indexOf('giftcard') !== -1) {
    return true;
  }

  var url = String(item.url || '').toLowerCase();
  if (url.indexOf('gift-card') !== -1 || url.indexOf('gift_card') !== -1) {
    return true;
  }

  return false;
};

jscIsGiftCardRestrictionExemptLine = (item) => {
  if (!item || !jscGiftCardGwpExemptionEnabled()) return false;
  var properties = item.properties || {};
  if (properties['_Cart_GWP'] === 'Free Gift') return true;
  if (properties['_Promo'] === 'Free Gift') return true;
  var cartGiftProp = properties['_Cart_Gift'];
  if (cartGiftProp !== undefined && cartGiftProp !== null && String(cartGiftProp) !== '') {
    return true;
  }
  return false;
};

jscGetGiftCardCartFlags = (cart) => {
  var flags = {
    cartHasGiftCard: false,
    cartHasNonGiftCard: false,
    giftCardQuantity: 0,
    checkoutBlocked: false
  };
  if (!cart || !cart.items) return flags;

  cart.items.forEach(function(item) {
    if (jscIsGiftCardCartItem(item)) {
      flags.cartHasGiftCard = true;
      flags.giftCardQuantity += parseInt(item.quantity, 10) || 1;
      jscRememberGiftCardProductId(item.product_id);
    } else if (!jscIsGiftCardRestrictionExemptLine(item)) {
      flags.cartHasNonGiftCard = true;
    }
  });

  flags.checkoutBlocked =
    (flags.cartHasGiftCard && flags.cartHasNonGiftCard) ||
    flags.giftCardQuantity > 1;

  return flags;
};

jscCollectGiftCardProductIdsFromDom = () => {
  $('[data-is-gift-card="true"][data-product-id]').each(function() {
    jscRememberGiftCardProductId($(this).attr('data-product-id'));
  });
  $('.jsc-cart-line-items[data-is-gift-card="true"]').each(function() {
    jscRememberGiftCardProductId($(this).attr('data-product-id'));
  });
};

jscGetLiveCartForGiftCardRestriction = () => {
  if (typeof CartJS !== 'undefined' && CartJS.cart && Array.isArray(CartJS.cart.items)) {
    return CartJS.cart;
  }
  return null;
};

jscIsProductFormGiftCard = ($form) => {
  if (!$form || !$form.length) return false;

  var attr = $form.attr('data-is-gift-card');
  if (attr === 'true' || attr === true || attr === '') return true;

  var $host = $form.closest('[data-is-gift-card]');
  if ($host.length) {
    var hostAttr = $host.attr('data-is-gift-card');
    if (hostAttr === 'true' || hostAttr === true || hostAttr === '') return true;
  }

  if ($form.closest('.jsc-pdp-template-gift-card, .product_form').hasClass('jsc-pdp-template-gift-card')) return true;
  if ($form.find('#is_gift_card').length) return true;

  return false;
};

jscEvaluateGiftCardAtcBlock = ($form) => {
  if (!jscGiftCardRestrictionEnabled()) return false;
  var state = jscEnsureGiftCardRestrictionState();
  var isGiftCardProduct = jscIsProductFormGiftCard($form);

  if (state.cartHasGiftCard) return true;
  if (isGiftCardProduct && state.cartHasNonGiftCard) return true;
  return false;
};

jscShowGiftCardDisclaimer = ($ctx) => {
  var $disclaimers = $();
  if ($ctx && $ctx.length) {
    $disclaimers = $ctx.find('.jsc-giftcard-disclaimer');
    if (!$disclaimers.length) {
      $disclaimers = $ctx.closest('.product_form, form, [data-product-form]').find('.jsc-giftcard-disclaimer');
    }
  }
  if (!$disclaimers.length) {
    $disclaimers = $('.jsc-giftcard-disclaimer').not('.jsc-giftcard-checkout-disclaimer');
  }
  $disclaimers.addClass('is-visible').prop('hidden', false).removeAttr('hidden');
};

jscSetGiftCardDisclaimerVisibility = ($disclaimer, visible) => {
  if (!$disclaimer || !$disclaimer.length) return;
  if (visible) {
    $disclaimer.addClass('is-visible').prop('hidden', false).removeAttr('hidden');
  } else {
    $disclaimer.removeClass('is-visible').prop('hidden', true).attr('hidden', true);
  }
};

// Feature OFF: GC lines behave like normal products — restore +/- steppers.
jscRestoreGiftCardDrawerQuantityControls = () => {
  $('.jsc-cart-line-items[data-is-gift-card="true"]').each(function() {
    var $lineItem = $(this);
    if ($lineItem.hasClass('jsc-dummy-cart-line-items')) return;
    if ($lineItem.attr('data-gwp') === 'true') return;

    var $selector = $lineItem.find('.jsc-qty-selector').first();
    if (!$selector.length) return;

    var qty = parseInt($selector.find('.cart-item__quantity-input').val(), 10);
    if (isNaN(qty) || qty < 1) {
      qty = parseInt($selector.find('.jsc-cart-drawer-gwp-fixed-qty').text(), 10) || 1;
    }

    $selector.find('.jsc-cart-drawer-gwp-fixed-qty').remove();
    $selector.removeClass('jsc-cart-drawer-free-gift-label');
    $selector.find('.jsc-cart-drawer-free-gift-span').remove();

    if (!$selector.find('.quantity').length) {
      var $templateSelector = $('.jsc-dummy-cart-line-items .jsc-qty-selector').first().clone(true, true);
      if ($templateSelector.length) {
        $selector.replaceWith($templateSelector);
        $selector = $lineItem.find('.jsc-qty-selector').first();
      }
    }

    var $input = $selector.find('.cart-item__quantity-input');
    if ($input.length) {
      $input.val(qty);
      $input.attr('value', qty);
      $input.attr('data-committed-qty', qty);
    }

    var maxQty = NaN;
    if (typeof jscGetCartDrawerQtyMax === 'function') {
      maxQty = jscGetCartDrawerQtyMax($input, $lineItem);
    }
    if (typeof jscSyncCartDrawerQtyControls === 'function' && $input.length) {
      jscSyncCartDrawerQtyControls($input, qty, maxQty);
    } else {
      var $minus = $selector.find('.minus');
      var $plus = $selector.find('.plus');
      if (qty <= 1) {
        $minus.addClass('unusable');
      } else {
        $minus.removeClass('unusable');
      }
      if (!isNaN(maxQty) && qty >= maxQty) {
        $plus.addClass('unusable');
      } else {
        $plus.removeClass('unusable');
      }
    }
  });
};

jscClearGiftCardRestrictionUI = () => {
  var state = jscEnsureGiftCardRestrictionState();
  state.cartHasGiftCard = false;
  state.cartHasNonGiftCard = false;
  state.giftCardQuantity = 0;
  state.checkoutBlocked = false;

  $('.product_form, .jsc-pdp-atc-btn-container').removeClass('jsc-giftcard-atc-blocked');
  $('.jsc-pdp-atc-btn, button[data-add-to-cart-trigger], button.button--add-to-cart')
    .removeClass('jsc-giftcard-atc-disabled')
    .attr('aria-disabled', 'false');
  jscSetGiftCardDisclaimerVisibility($('.jsc-giftcard-disclaimer'), false);

  $('.jsc-cart-drawer-footer-2, .cart__checkout, .jsc-giftcard-checkout')
    .removeClass('jsc-giftcard-checkout-blocked');
  var $checkoutBtns = $(
    '.jsc-cart-drawer-checkout-button, #cart_form [name="checkout"], #checkout.jsc-giftcard-checkout-btn, .jsc-giftcard-checkout-btn'
  );
  $checkoutBtns.removeClass('jsc-giftcard-checkout-disabled').attr('aria-disabled', 'false');
  $checkoutBtns.each(function() {
    var $btn = $(this);
    if ($btn.is('button, input') && ($btn.hasClass('jsc-giftcard-checkout-btn') || $btn.is('#checkout'))) {
      $btn.removeAttr('disabled');
    }
  });

  jscRestoreGiftCardDrawerQuantityControls();
};

jscApplyGiftCardAtcState = () => {
  // When restrictions are off, never block ATC — gift cards behave like normal products.
  if (!jscGiftCardRestrictionEnabled()) {
    $('.product_form, .jsc-pdp-atc-btn-container').removeClass('jsc-giftcard-atc-blocked');
    $('.jsc-pdp-atc-btn, button[data-add-to-cart-trigger], button.button--add-to-cart')
      .removeClass('jsc-giftcard-atc-disabled')
      .attr('aria-disabled', 'false');
    jscSetGiftCardDisclaimerVisibility($('.jsc-giftcard-pdp-disclaimer, .jsc-giftcard-disclaimer').not('.jsc-giftcard-checkout-disclaimer'), false);
    return;
  }

  jscCollectGiftCardProductIdsFromDom();

  $('form[action*="/cart/add"], .product_form form').each(function() {
    var $form = $(this);
    var blocked = jscEvaluateGiftCardAtcBlock($form);
    var $container = $form.find('.jsc-pdp-atc-btn-container');
    var $host = $form.closest('.product_form');
    var $atcBtns = $form.find('.jsc-pdp-atc-btn, button[data-add-to-cart-trigger], button.button--add-to-cart');

    if ($container.length) {
      $container.toggleClass('jsc-giftcard-atc-blocked', blocked);
    }
    if ($host.length) {
      $host.toggleClass('jsc-giftcard-atc-blocked', blocked);
    }

    if ($atcBtns.length) {
      $atcBtns.toggleClass('jsc-giftcard-atc-disabled', blocked);
      $atcBtns.attr('aria-disabled', blocked ? 'true' : 'false');
    }

    var $disclaimer = $form.find('.jsc-giftcard-disclaimer, .jsc-giftcard-pdp-disclaimer');
    if (!$disclaimer.length && $host.length) {
      $disclaimer = $host.find('.jsc-giftcard-disclaimer, .jsc-giftcard-pdp-disclaimer');
    }
    if (!$disclaimer.length) {
      $disclaimer = $form.closest('.purchase-details, .product_form').find('.jsc-giftcard-pdp-disclaimer');
    }
    jscSetGiftCardDisclaimerVisibility($disclaimer, blocked);
  });
};

jscApplyGiftCardCheckoutState = () => {
  if (!jscGiftCardRestrictionEnabled()) {
    $('.jsc-cart-drawer-footer-2, .cart__checkout, .jsc-giftcard-checkout')
      .removeClass('jsc-giftcard-checkout-blocked');
    var $checkoutBtnsOff = $(
      '.jsc-cart-drawer-checkout-button, #cart_form [name="checkout"], #checkout.jsc-giftcard-checkout-btn, .jsc-giftcard-checkout-btn'
    );
    $checkoutBtnsOff.removeClass('jsc-giftcard-checkout-disabled').attr('aria-disabled', 'false');
    $checkoutBtnsOff.each(function() {
      var $btn = $(this);
      if ($btn.is('button, input') && ($btn.hasClass('jsc-giftcard-checkout-btn') || $btn.is('#checkout'))) {
        $btn.removeAttr('disabled');
      }
    });
    jscSetGiftCardDisclaimerVisibility($('.jsc-giftcard-checkout-disclaimer'), false);
    return;
  }

  var state = jscEnsureGiftCardRestrictionState();
  var blocked = !!state.checkoutBlocked;
  var $containers = $(
    '.jsc-cart-drawer-footer-2, .cart__checkout, .jsc-giftcard-checkout'
  );
  var $checkoutBtns = $(
    '.jsc-cart-drawer-checkout-button, #cart_form [name="checkout"], #checkout.jsc-giftcard-checkout-btn, .jsc-giftcard-checkout-btn'
  );
  var $disclaimers = $('.jsc-giftcard-checkout-disclaimer');

  $containers.toggleClass('jsc-giftcard-checkout-blocked', blocked);
  $checkoutBtns.toggleClass('jsc-giftcard-checkout-disabled', blocked);
  $checkoutBtns.attr('aria-disabled', blocked ? 'true' : 'false');

  $checkoutBtns.each(function() {
    var $btn = $(this);
    if ($btn.is('button, input')) {
      if (blocked) {
        $btn.attr('disabled', 'disabled');
      } else if ($btn.hasClass('jsc-giftcard-checkout-btn') || $btn.is('#checkout')) {
        $btn.removeAttr('disabled');
      }
    }
  });

  jscSetGiftCardDisclaimerVisibility($disclaimers, blocked);
};

jscGateGiftCardCheckout = (el, evt) => {
  if (!jscGiftCardRestrictionEnabled()) return true;

  var liveCart = jscGetLiveCartForGiftCardRestriction();
  if (liveCart) {
    jscSyncGiftCardRestrictionFromCart(liveCart);
  }

  var state = jscEnsureGiftCardRestrictionState();
  if (!state.checkoutBlocked) return true;

  if (evt) {
    evt.preventDefault();
    evt.stopPropagation();
  }
  jscApplyGiftCardCheckoutState();
  jscSetGiftCardDisclaimerVisibility($('.jsc-giftcard-checkout-disclaimer'), true);
  return false;
};

jscSyncGiftCardRestrictionFromCart = (cart) => {
  if (!cart) return;
  if (!jscGiftCardRestrictionEnabled()) {
    jscClearGiftCardRestrictionUI();
    return;
  }
  jscCollectGiftCardProductIdsFromDom();
  var state = jscEnsureGiftCardRestrictionState();
  var flags = jscGetGiftCardCartFlags(cart);
  state.cartHasGiftCard = flags.cartHasGiftCard;
  state.cartHasNonGiftCard = flags.cartHasNonGiftCard;
  state.giftCardQuantity = flags.giftCardQuantity;
  state.checkoutBlocked = flags.checkoutBlocked;
  // Re-stamp from cart.js so SSR lines that missed Liquid GC detection still lose steppers.
  jscStampGiftCardDrawerLinesFromCart(cart);
  jscApplyGiftCardAtcState();
  jscApplyGiftCardCheckoutState();
  jscApplyGiftCardLockedQtyInDrawer();
};

jscApplyGiftCardLockedQtyInDrawer = () => {
  // Feature inactive → GC qty steppers like any other product.
  if (!jscGiftCardRestrictionEnabled()) {
    jscRestoreGiftCardDrawerQuantityControls();
    return;
  }

  // Feature active → replace GC steppers with a static quantity.
  $('.jsc-cart-line-items[data-is-gift-card="true"]').each(function() {
    var $lineItem = $(this);
    if ($lineItem.hasClass('jsc-dummy-cart-line-items')) return;
    if ($lineItem.attr('data-gwp') === 'true') return;
    jscApplyCartDrawerGiftCardFixedQuantity($lineItem);
  });
};

jscInitGiftCardRestriction = () => {
  if (!jscGiftCardRestrictionEnabled()) {
    // Feature off: treat gift cards like normal products (multi-qty ATC + editable cart qty).
    jscClearGiftCardRestrictionUI();
    return;
  }

  jscCollectGiftCardProductIdsFromDom();
  jscApplyGiftCardAtcState();
  jscApplyGiftCardCheckoutState();
  jscApplyGiftCardLockedQtyInDrawer();

  fetch('/cart.js')
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      jscSyncGiftCardRestrictionFromCart(cart);
    })
    .catch(function() {});

  $(document).on(
    'click',
    '.jsc-cart-drawer-checkout-button, #cart_form [name="checkout"], #checkout, .jsc-giftcard-checkout-btn',
    function(e) {
      var $el = $(this);
      if (
        !$el.is('.jsc-cart-drawer-checkout-button, #cart_form [name="checkout"], #checkout, .jsc-giftcard-checkout-btn') &&
        !$el.closest('.jsc-cart-drawer-footer-2, .cart__checkout, .jsc-giftcard-checkout').length
      ) {
        return;
      }
      return jscGateGiftCardCheckout(this, e);
    }
  );

  $(document).on('submit', '#cart_form', function(e) {
    if (!jscGiftCardRestrictionEnabled()) return;
    var state = jscEnsureGiftCardRestrictionState();
    if (!state.checkoutBlocked) return;

    var submitter = e.originalEvent && e.originalEvent.submitter;
    if (
      submitter &&
      (submitter.getAttribute('name') === 'checkout' || submitter.id === 'checkout')
    ) {
      e.preventDefault();
      jscApplyGiftCardCheckoutState();
      return false;
    }
  });
};

jscGateGiftCardAtc = (el) => {
  if (!jscGiftCardRestrictionEnabled()) return true;
  var $el = $(el);
  var $form = $el.closest('form');
  if (!$form.length) {
    $form = $el.closest('.product_form').find('form').first();
  }

  var liveCart = jscGetLiveCartForGiftCardRestriction();
  if (liveCart) {
    jscSyncGiftCardRestrictionFromCart(liveCart);
  }

  if (jscEvaluateGiftCardAtcBlock($form)) {
    if (jscIsProductFormGiftCard($form)) {
      jscRememberGiftCardProductId($form.closest('[data-product-id]').attr('data-product-id') || $form.attr('data-product-id'));
    }
    jscApplyGiftCardAtcState();
    jscShowGiftCardDisclaimer($form);
    return false;
  }
  if (jscIsProductFormGiftCard($form)) {
    jscRememberGiftCardProductId($form.closest('[data-product-id]').attr('data-product-id') || $form.attr('data-product-id'));
  }
  return true;
};

jscGateGiftCardAtcAsync = (el) => {
  if (!jscGiftCardRestrictionEnabled()) {
    return Promise.resolve(true);
  }

  return fetch('/cart.js')
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      jscSyncGiftCardRestrictionFromCart(cart);
      return jscGateGiftCardAtc(el);
    })
    .catch(function() {
      return jscGateGiftCardAtc(el);
    });
};

jscShouldBlockGwpAutoAddForGiftCard = (cart) => {
  if (!jscGiftCardRestrictionEnabled()) return false;
  if (jscGiftCardGwpExemptionEnabled()) return false;

  if (cart && Array.isArray(cart.items)) {
    for (var i = 0; i < cart.items.length; i++) {
      if (jscIsGiftCardCartItem(cart.items[i])) return true;
    }
    return false;
  }

  var state = jscEnsureGiftCardRestrictionState();
  if (state.cartHasGiftCard) return true;

  var liveCart = jscGetLiveCartForGiftCardRestriction();
  if (liveCart && Array.isArray(liveCart.items)) {
    for (var j = 0; j < liveCart.items.length; j++) {
      if (jscIsGiftCardCartItem(liveCart.items[j])) return true;
    }
  }
  return false;
};

jscCartContainsGiftCard = (cart) => {
  if (!cart || !Array.isArray(cart.items)) return false;
  for (var i = 0; i < cart.items.length; i++) {
    if (jscIsGiftCardCartItem(cart.items[i])) return true;
  }
  return false;
};

jscGetFreeDeliveryEligibleTotal = (cart) => {
  if (!cart) return 0;
  var total = parseInt(cart.total_price, 10) || 0;
  if (!jscExcludeGiftcardFromFreeDelivery() || !Array.isArray(cart.items)) {
    return total;
  }

  cart.items.forEach(function(item) {
    if (!jscIsGiftCardCartItem(item)) return;
    var linePrice = parseInt(item.final_line_price, 10);
    if (isNaN(linePrice)) {
      linePrice = parseInt(item.line_price, 10);
    }
    if (!isNaN(linePrice)) {
      total -= linePrice;
    }
  });

  return total > 0 ? total : 0;
};
//end: gift card cart restriction

//start: pdp atc
jscClickATC = () => {
  var pageUrl = window.location.href;
  var varID = pageUrl.split('variant=')[1];
  jscUpdateCartDrawer(varID);
  setTimeout(function(){
    jscOpenCartDrawer();
  },500);
}
jscCustomATC = async (e) => {
  if (e && !(await jscGateGiftCardAtcAsync(e))) return;

  var varID = $('.variant-selection').attr('variant');
  await cartJSAddQuery(varID,1,{},true);
  setTimeout(function(){
    jscUpdateCartDrawer(varID);
  },200);
  setTimeout(function(){
    jscOpenCartDrawer();
  },1000);
}
//end 

//start: side cart drawer
jscOpenCartDrawer = () => {
  $('.jsc-cart-drawer-div').addClass('open-cart-drawer');
  $('.jsc-cart-drawer-overlay').removeClass('d-none');

  //start: close drawer when clicked outside
  $('.jsc-cart-drawer-overlay').click(function(){
    jscCloseCartDrawer();
  });
  //end: close drawer when clicked outside
}
jscCloseCartDrawer = () => {
  $('.jsc-cart-drawer-div').removeClass('open-cart-drawer');
  $('.jsc-cart-drawer-overlay').addClass('d-none');
}
jscUpdateCartDrawer = (varID,isGwpInCart) => {
  console.log('update cart drawer');
  setTimeout(function(){
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      var $cartItems = data.items;
      var $cartDrawerItems = $('.jsc-cart-items-section')
      var giftRemovalVariantId = false;

      if (typeof isGwpInCart === 'number' && !isNaN(isGwpInCart)) {
        giftRemovalVariantId = parseInt(isGwpInCart, 10);
      } else if (isGwpInCart === true) {
        var $giftRemovalInput = $('.jsc-cart-gift-remove').first();
        if ($giftRemovalInput.length) {
          var variantAttr = parseInt($giftRemovalInput.attr('data-variant-id'), 10);
          if (!isNaN(variantAttr)) {
            giftRemovalVariantId = variantAttr;
          } else {
            var parseFallback = parseInt($giftRemovalInput.val(), 10);
            if (!isNaN(parseFallback)) {
              giftRemovalVariantId = parseFallback;
            }
          }
        }
      }

      console.log('isGwpInCart from update drawer',isGwpInCart);
      if (giftRemovalVariantId) {
        console.log('Removing gift variant from drawer', giftRemovalVariantId);
        $cartDrawerItems.children().each(function(){
          var $thisID = parseInt($(this).attr('data-var-id'), 10);
          if ($thisID == giftRemovalVariantId) {
            $(this).remove();
          }
        });
      }

      var _sgMinPrice = parseInt($('.jsc-cart-freedelivery-section .cart-shipping__wrapper').attr('minprice-aud'));
      var _gwpMinPrice = parseInt($('.jsc-cart-freegift-section .cart-shipping__wrapper').attr('minprice-aud'));
      calculateProgress(data.total_price, _sgMinPrice);
      calculateProgressGWP(data.total_price, _gwpMinPrice);
      jscSyncGiftCardRestrictionFromCart(data);

      //start: update cart drawer header
      var $drawerHeader = $('.jsc-cart-drawer-header');
      $drawerHeader.find('.cart-link__count').html(data.item_count);
      $drawerHeader.find('.cart-drawer-qty').html(data.item_count);
      $('.header-cart').find('.cart-link__count').html(data.item_count); //nav cart icon
      //end: update cart drawer header

      //start: update cart drawer content
        for (var i = 0; i < $cartItems.length; i++) {
          var $cartItem = $cartItems[i];
          var $itemID = $cartItem.id;
          var $itemQty = $cartItem.quantity;
          var $itemProdTitle = $cartItem.product_title;
          var $itemVarOpt = $cartItem.options_with_values;
          var $itemUrl = $cartItem.url;
          var $itemImage = $cartItem.featured_image.url;
          var $itemImageAlt = $cartItem.featured_image.alt;
          var $itemPrice = $cartItem.original_price;
          var $itemPriceDiscounted = typeof $cartItem.final_price !== 'undefined' ? $cartItem.final_price : $cartItem.discounted_price;
          var $itemDiscountAllocations = $cartItem.line_level_discount_allocations || [];
          var $isItemInDrawer = false;
          var $itemKey = $cartItem.key;
          var $itemProperties = $cartItem.properties || {};
          var $itemGiftProp = $itemProperties['_Cart_GWP'];
          var $itemGiftPromo = $itemProperties['_Cart_Gift'];
          var $isGiftItem = $itemGiftProp && $itemGiftProp.toString().length > 0;
          var $isGiftCardItem = jscIsGiftCardCartItem($cartItem);
          if ($isGiftCardItem) {
            jscRememberGiftCardProductId($cartItem.product_id);
          }
          //console.log('$itemID',$itemID);
  
          $cartDrawerItems.children().each(function(){
            var $thisID = $(this).attr('data-var-id');
  
            if ($thisID == $itemID) {
              
              $isItemInDrawer = true;
              var $lineItem = $(this);
              $lineItem.attr('data-is-gift-card', $isGiftCardItem ? 'true' : 'false');
              if ($cartItem.product_id) {
                $lineItem.attr('data-product-id', $cartItem.product_id);
              }
              updateCartDrawerGiftState($lineItem, $isGiftItem, $itemQty, $itemGiftPromo);
              jscRenderCartDrawerDiscounts($lineItem, $itemDiscountAllocations, $cartItem.line_level_total_discount);
              (function(lineItem, cartItem, itemPrice, itemPriceDiscounted){
                jscResolveCompareAtPrice(cartItem).then(function(itemCompareAtPrice){
                  jscApplyCartDrawerLineItemPrice(lineItem, itemPrice, itemPriceDiscounted, itemCompareAtPrice);
                });
              })($lineItem, $cartItem, $itemPrice, $itemPriceDiscounted);

              if (varID == $thisID) { //update the content of matching variant ID
                console.log('update qty of',$itemID);
                if ($isGiftCardItem && jscGiftCardRestrictionEnabled()) {
                  jscApplyCartDrawerGiftCardFixedQuantity($lineItem, $itemQty);
                } else {
                  var $qtyInput = $lineItem.find('.cart-item__quantity-input');
                  $qtyInput.val($itemQty);
                  $qtyInput.attr('value', $itemQty);
                  $qtyInput.attr('data-committed-qty', $itemQty);
                  if (parseInt($itemQty, 10) > 1) {
                    $lineItem.find('.minus').removeClass('unusable');
                  } else {
                    $lineItem.find('.minus').addClass('unusable');
                  }
                }
              }
            }
            
          });
          //console.log('$isItemInDrawer',$isItemInDrawer,$itemID);
          if ($isItemInDrawer == true) {
            jscOpenCartDrawer();
          } else {
            //if item is not in cart drawer yet, build the grid
            (function(cartItem, itemID, itemQty, itemProdTitle, itemVarOpt, itemUrl, itemImage, itemImageAlt, itemPrice, itemPriceDiscounted, itemDiscountAllocations, isGiftItem, itemKey, itemGiftPromo){
              jscResolveCompareAtPrice(cartItem).then(function(itemCompareAtPrice){
                var existingLine = $cartDrawerItems.children('[data-var-id="' + itemID + '"]');
                if (existingLine.length) {
                  jscApplyCartDrawerLineItemPrice(existingLine.first(), itemPrice, itemPriceDiscounted, itemCompareAtPrice);
                  jscRenderCartDrawerDiscounts(existingLine.first(), itemDiscountAllocations, cartItem.line_level_total_discount);
                  return;
                }
                jscCreateCartGrid(itemID,itemQty,itemProdTitle,itemVarOpt,itemUrl,itemImage,itemImageAlt,itemPrice,itemPriceDiscounted,isGiftItem,itemKey,itemCompareAtPrice,itemDiscountAllocations,itemGiftPromo,cartItem);
              });
            })($cartItem,$itemID,$itemQty,$itemProdTitle,$itemVarOpt,$itemUrl,$itemImage,$itemImageAlt,$itemPrice,$itemPriceDiscounted,$itemDiscountAllocations,$isGiftItem,$itemKey,$itemGiftPromo);
          }
        }
        //end: update cart drawer content

        //start: update cart drawer footer
        var $drawerFooter = $('.jsc-cart-drawer-footer');
        var format_CartPrice = Shopify.formatMoney(data.total_price, $('body').data('money'));
        var currency_CartPrice = format_CartPrice.replace('undefined','$');
        $drawerFooter.find('.jsc-cart-drawer-total').html(currency_CartPrice);
        //end: update cart drawer footer

        jscApplyGiftCardLockedQtyInDrawer();
        jscApplyGiftCardCheckoutState();
        refreshCartGiftMarkup(['jsc-section-cart-drawer']);
      });
    //document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    },120);
  
}
window.jscVariantCompareAtPriceCache = window.jscVariantCompareAtPriceCache || {};
window.jscProductVariantCompareAtCache = window.jscProductVariantCompareAtCache || {};
window.jscCartDrawerDiscountTemplate = window.jscCartDrawerDiscountTemplate || '';

jscResolveCompareAtPrice = (cartItem) => {
  if (!cartItem) {
    return Promise.resolve(null);
  }

  var itemKey = cartItem.key;
  var variantId = parseInt(cartItem.id, 10);
  var compareAtPrice = null;

  if (window.cartComparePrices && itemKey && typeof window.cartComparePrices[itemKey] !== 'undefined') {
    compareAtPrice = parseInt(window.cartComparePrices[itemKey], 10);
    if (!isNaN(compareAtPrice) && compareAtPrice > 0) {
      window.jscVariantCompareAtPriceCache[variantId] = compareAtPrice;
      return Promise.resolve(compareAtPrice);
    }
  }

  if (!isNaN(variantId) && typeof window.jscVariantCompareAtPriceCache[variantId] === 'number') {
    return Promise.resolve(window.jscVariantCompareAtPriceCache[variantId]);
  }

  var pdpVariantInput = $('.jsc-product-variant-details').find('[data-var-id="' + variantId + '"]');
  if (pdpVariantInput.length) {
    compareAtPrice = parseInt(pdpVariantInput.attr('data-compare-at-price'), 10);
    if (!isNaN(compareAtPrice) && compareAtPrice > 0) {
      window.jscVariantCompareAtPriceCache[variantId] = compareAtPrice;
      if (window.cartComparePrices && itemKey) {
        window.cartComparePrices[itemKey] = compareAtPrice;
      }
      return Promise.resolve(compareAtPrice);
    }
  }

  var productHandle = cartItem.handle;
  if (!productHandle) {
    return Promise.resolve(null);
  }

  var productCache = window.jscProductVariantCompareAtCache[productHandle];
  if (productCache && typeof productCache[variantId] !== 'undefined') {
    compareAtPrice = productCache[variantId];
    if (typeof compareAtPrice === 'number' && compareAtPrice > 0) {
      window.jscVariantCompareAtPriceCache[variantId] = compareAtPrice;
      if (window.cartComparePrices && itemKey) {
        window.cartComparePrices[itemKey] = compareAtPrice;
      }
      return Promise.resolve(compareAtPrice);
    }
    return Promise.resolve(null);
  }

  return fetch('/products/' + encodeURIComponent(productHandle) + '.js', { credentials: 'same-origin' })
    .then(function(response){
      if (!response.ok) {
        return null;
      }
      return response.json();
    })
    .then(function(productData){
      var compareByVariantId = {};

      if (productData && Array.isArray(productData.variants)) {
        for (var idx = 0; idx < productData.variants.length; idx++) {
          var productVariant = productData.variants[idx];
          var currentVariantId = parseInt(productVariant.id, 10);
          var currentCompareAt = parseInt(productVariant.compare_at_price, 10);

          compareByVariantId[currentVariantId] = !isNaN(currentCompareAt) && currentCompareAt > 0 ? currentCompareAt : null;
        }
      }

      window.jscProductVariantCompareAtCache[productHandle] = compareByVariantId;
      compareAtPrice = compareByVariantId[variantId];

      if (typeof compareAtPrice === 'number' && compareAtPrice > 0) {
        window.jscVariantCompareAtPriceCache[variantId] = compareAtPrice;
        if (window.cartComparePrices && itemKey) {
          window.cartComparePrices[itemKey] = compareAtPrice;
        }
        return compareAtPrice;
      }

      return null;
    })
    .catch(function(){
      return null;
    });
}

jscApplyCartDrawerLineItemPrice = ($lineItem, itemPrice, itemDiscountedPrice, itemCompareAtPrice) => {
  var $line = $lineItem instanceof jQuery ? $lineItem : $($lineItem);
  var itemPriceVal = parseInt(itemPrice, 10);
  var itemDiscountedPriceVal = parseInt(itemDiscountedPrice, 10);
  var itemCompareAtPriceVal = parseInt(itemCompareAtPrice, 10);

  if (isNaN(itemPriceVal)) {
    itemPriceVal = 0;
  }

  if (isNaN(itemDiscountedPriceVal)) {
    itemDiscountedPriceVal = itemPriceVal;
  }

  var hasOriginalPriceDiscount = itemDiscountedPriceVal < itemPriceVal;
  var hasCompareAtDiscount = !isNaN(itemCompareAtPriceVal) && itemCompareAtPriceVal > itemDiscountedPriceVal;
  var strikeOutPriceVal = null;

  var formatVarPriceDisc = Shopify.formatMoney(itemDiscountedPriceVal, $('body').data('money'));
  var currencyVarPriceDisc = formatVarPriceDisc.replace('undefined','$');
  var $priceContainer = $line.find('.cart-line-item-price');
  var $primaryStrikeOutPrice = $priceContainer.find('.jsc-struck-out-price').first();

  if (!$primaryStrikeOutPrice.length) {
    $primaryStrikeOutPrice = $('<div class="jsc-struck-out-price d-none"><span class="theme-money"></span></div>');
    $priceContainer.prepend($primaryStrikeOutPrice);
  }

  // If a cart discount exists, show original price above discounted price.
  // Otherwise, keep compare-at behavior for regular sale items.
  if (hasOriginalPriceDiscount) {
    strikeOutPriceVal = itemPriceVal;
  } else if (hasCompareAtDiscount) {
    strikeOutPriceVal = itemCompareAtPriceVal;
  }

  $priceContainer.find('.jsc-original-price').remove();

  if (strikeOutPriceVal !== null) {
    var formatStruckOutPrice = Shopify.formatMoney(strikeOutPriceVal, $('body').data('money'));
    var currencyStruckOutPrice = formatStruckOutPrice.replace('undefined','$');

    $primaryStrikeOutPrice.removeClass('d-none');
    $primaryStrikeOutPrice.find('.theme-money').text(currencyStruckOutPrice);
    $line.find('.cart-line-item-price .jsc-variant-price').addClass('jsc-sale-price');
    $line.find('.cart-line-item-price .jsc-variant-price .theme-money').text(currencyVarPriceDisc);
  } else {
    $primaryStrikeOutPrice.addClass('d-none');
    $line.find('.cart-line-item-price .jsc-variant-price').removeClass('jsc-sale-price');
    $line.find('.cart-line-item-price .jsc-variant-price .theme-money').text(currencyVarPriceDisc);
  }
}

jscRenderCartDrawerDiscounts = ($lineItem, discountAllocations, lineLevelTotalDiscount) => {
  var $line = $lineItem instanceof jQuery ? $lineItem : $($lineItem);
  var $titleContainer = $line.find('.cart-line-item-prod-var-title').first();

  if (!$titleContainer.length) {
    return;
  }

  // Always clear existing rows first so a prior AJAX paint cannot leave stale labels.
  $titleContainer.find('.jsc-cart-drawer-discount').remove();
  $titleContainer.find('.line-item-discount__container').remove();

  if (!Array.isArray(discountAllocations) || !discountAllocations.length) {
    return;
  }

  var isFreeGiftLine = $line.attr('data-gwp') === 'true';

  if (!window.jscCartDrawerDiscountTemplate) {
    var $template = $('.jsc-cart-drawer-discount-template .line-item-discount__container.jsc-cart-drawer-discount').first();
    if ($template.length) {
      window.jscCartDrawerDiscountTemplate = $template.prop('outerHTML');
    }
  }

  var $insertionPoint = $titleContainer.find('.cart-line-item-var-title').last();

  for (var discountIdx = 0; discountIdx < discountAllocations.length; discountIdx++) {
    var discountAllocation = discountAllocations[discountIdx];
    var discountTitle = discountAllocation && discountAllocation.discount_application ? discountAllocation.discount_application.title : '';
    var allocationAmount = discountAllocation ? parseInt(discountAllocation.amount, 10) : 0;
    var normalizedTitle = String(discountTitle).trim().toLowerCase();

    if (!discountTitle || isNaN(allocationAmount) || allocationAmount <= 0) {
      continue;
    }

    if (!isFreeGiftLine && normalizedTitle.indexOf('free gift') !== -1) {
      continue;
    }

    var $discountRow = window.jscCartDrawerDiscountTemplate
      ? $(window.jscCartDrawerDiscountTemplate)
      : $('<div class="line-item-discount__container jsc-cart-drawer-discount"><p></p></div>');

    $discountRow.find('p').text(discountTitle);

    if ($insertionPoint.length) {
      $discountRow.insertAfter($insertionPoint);
    } else {
      $titleContainer.append($discountRow);
    }

    $insertionPoint = $discountRow;
  }
}

jscCreateCartGrid = ($itemID,$itemQty,$itemProdTitle,$itemVarOpt,$itemUrl,$itemImage,$itemImageAlt,$itemPrice,$itemPriceDiscounted,isGiftItem,$itemKey,$itemCompareAtPrice,itemDiscountAllocations,promoNo,cartItem) => {
  //console.log($itemID,$itemPriceDiscounted,$itemPrice);
  var $cloneGrid = $('.jsc-cart-items-section').find('.jsc-dummy-cart-line-items.jsc-cart-line-items').first().clone();
  var $getVarDetails = $('.jsc-product-variant-details');
  var $thisMaxQty;
  var isGiftCardItem = cartItem ? jscIsGiftCardCartItem(cartItem) : false;

  var isGiftCardLockedQty =
    isGiftCardItem &&
    typeof jscGiftCardRestrictionEnabled === 'function' &&
    jscGiftCardRestrictionEnabled();

  $getVarDetails.children().each(function(){
    var $thisID = $(this).attr('data-var-id');
    if ($itemID == $thisID) {
      $thisMaxQty = $(this).attr('data-max-qty');
      // GC + restriction off: do not inherit PDP inventory_quantity as a hard max.
      // Gift cards often report 0/1 inventory and that incorrectly hides the plus control.
      if (isGiftCardItem && !isGiftCardLockedQty) {
        $cloneGrid.find('.jsc-product-details-input').removeAttr('data-max-qty');
        $cloneGrid.find('.jsc-qty-selector .plus').removeClass('unusable');
        return;
      }
      $cloneGrid.find('.jsc-product-details-input').attr('data-max-qty',$thisMaxQty);
      var maxQtyNum = parseInt($thisMaxQty, 10);
      if (!isNaN(maxQtyNum) && maxQtyNum <= 1) {
        $cloneGrid.find('.jsc-qty-selector .plus').addClass('unusable');
      }
    }
  });

  $cloneGrid.find('.cart-line-item-img a').attr('href',$itemUrl);
  $cloneGrid.find('.cart-line-item-img img').attr('src',$itemImage);
  $cloneGrid.find('.cart-line-item-img img').attr('alt',$itemImageAlt);
  $cloneGrid.find('.cart-line-item-prod-title a').text($itemProdTitle);
  $cloneGrid.attr('data-var-id',$itemID);
  $cloneGrid.attr('data-key',$itemKey);
  $cloneGrid.attr('data-gwp','false');
  $cloneGrid.attr('data-is-gift-card', isGiftCardItem ? 'true' : 'false');
  if (cartItem && cartItem.product_id) {
    $cloneGrid.attr('data-product-id', cartItem.product_id);
    if (isGiftCardItem) {
      jscRememberGiftCardProductId(cartItem.product_id);
    }
  }
  $cloneGrid.find('.cart-line-item-var-title').remove();
  $cloneGrid.find('.jsc-qty-selector input').val($itemQty);
  $cloneGrid.find('.jsc-qty-selector input').attr('value', $itemQty);
  $cloneGrid.find('.jsc-qty-selector input').attr('data-committed-qty', $itemQty);
  if (isGiftCardLockedQty) {
    // Foxwood: apply fixed qty directly when creating the line (never leave steppers briefly).
    jscApplyCartDrawerGiftCardFixedQuantity($cloneGrid, $itemQty);
  } else {
    updateCartDrawerGiftState($cloneGrid, isGiftItem, $itemQty, promoNo);
  }
  jscApplyCartDrawerLineItemPrice($cloneGrid, $itemPrice, $itemPriceDiscounted, $itemCompareAtPrice);
  
  //console.log('currency_varPrice',currency_varPrice);
  // Foxwood #17557: render any option (incl. GC denominations), skip Default Title.
  if (Array.isArray($itemVarOpt)) {
    for (var j = 0; j < $itemVarOpt.length; j++) {
      var $optionValue = $itemVarOpt[j].value;
      if ($optionValue === 'Default Title') {
        continue;
      }
      var $optionName = $itemVarOpt[j].name + ': ';
      $cloneGrid.find('.cart-line-item-prod-var-title').append(
        '<div class="cart-line-item-var-title"><span class="jsc-option-name">' +
          $optionName +
          '</span><span class="jsc-option-val">' +
          $optionValue +
          '</span></div>'
      );
    }
  }
  var lineLevelTotalDiscount = cartItem && typeof cartItem.line_level_total_discount !== 'undefined'
    ? cartItem.line_level_total_discount
    : 0;
  jscRenderCartDrawerDiscounts($cloneGrid, itemDiscountAllocations || [], lineLevelTotalDiscount);
  $cloneGrid.removeClass('d-none').removeClass('jsc-dummy-cart-line-items');
  //$cloneGrid.appendTo('.jsc-cart-items-section');
  $cloneGrid.insertAfter('.jsc-dummy-cart-line-items.jsc-cart-line-items');
  jscOpenCartDrawer();
}
//end: side cart drawer

//start: calculate free shipping
calculateProgress = (currentVal, targetVal) => {

  var freeDeliverySection = $('.jsc-cart-freedelivery-section')
  var cartMinText = freeDeliverySection.find('.cart-shipping__wrapper').attr('minprice-aud');
  var cartMinVal = parseInt(cartMinText);
  var progressBar = freeDeliverySection.find('.cart-shippingThreshold__progress');
  var progressNum = freeDeliverySection.find('.cart-shipping__num');
  var progressOuter = freeDeliverySection.find('.cart-shipping__numOuter');
  var successMsg = freeDeliverySection.find('.cart-shipping__success');
  var $cartBars = $(
    '.jsc-cart-drawer-div .jsc-cart-freedelivery-section, .jsc-cartpage-shipping-gwp-section .jsc-cart-freedelivery-section'
  );

  if (freeDeliverySection.length > 0) {
    $.when($.getJSON('/cart.js', function(cart) {
      var hideCartBars = jscExcludeGiftcardFromFreeDelivery() && jscCartContainsGiftCard(cart);
      var _totalPrice = jscGetFreeDeliveryEligibleTotal(cart);
      var $visibleBars = freeDeliverySection;

      if (hideCartBars) {
        $cartBars.addClass('d-none');
        $visibleBars = freeDeliverySection.not($cartBars);
        progressBar = $visibleBars.find('.cart-shippingThreshold__progress');
        progressNum = $visibleBars.find('.cart-shipping__num');
        progressOuter = $visibleBars.find('.cart-shipping__numOuter');
        successMsg = $visibleBars.find('.cart-shipping__success');
      }
      
      if (_totalPrice > 0 && $visibleBars.length) {
        $visibleBars.removeClass('d-none');
        var calcFreeDeliveryVal = (cartMinVal - _totalPrice) / 100;
        var progressWidth = Math.round(100 * _totalPrice / cartMinVal);
        if (progressWidth >= 100) {
          progressWidth = 100;
        }
        var progressWidthPercent = progressWidth.toString() + '%';

        progressBar.each(function(){
          $(this).css({
            width: progressWidthPercent
          });
        });

        if (_totalPrice >= cartMinVal) {
          console.log('free delivery');
          progressOuter.hide();
          successMsg.show();
        } else {
          console.log('still short from free delivery',calcFreeDeliveryVal);
          progressNum.text(calcFreeDeliveryVal);
          progressOuter.show();
          successMsg.hide();
        }
      }
      else{
        if (hideCartBars) {
          $cartBars.addClass('d-none');
        } else {
          freeDeliverySection.addClass('d-none');
        }
      }
      
    })).then(function() {
      
    });
  }
};
//end: calculate free shipping
fetch('/cart.js')
.then(response => response.json())
.then(data => {
  var _sgMinPrice = parseInt($('.jsc-cart-freedelivery-section .cart-shipping__wrapper').attr('minprice-aud'));
  var _gwpMinPrice = parseInt($('.jsc-cart-freegift-section .cart-shipping__wrapper').attr('minprice-aud'));
  //calculateProgress(data.total_price, _sgMinPrice);
  //calculateProgressGWP(data.total_price, _gwpMinPrice);
});
//end: calculate free shipping

//start: cart drawer qty selector
jscSyncCartDrawerQtyControls = ($input, count, maxQty) => {
  var $minus = $input.siblings('.minus');
  var $plus = $input.siblings('.plus');

  if (count <= 1) {
    $minus.addClass('unusable');
  } else {
    $minus.removeClass('unusable');
  }

  if (!isNaN(maxQty) && count >= maxQty) {
    $plus.addClass('unusable');
  } else {
    $plus.removeClass('unusable');
  }
}

jscGetCartDrawerQtyMax = ($input, $lineItem) => {
  // Unrestricted gift cards: ignore inventory-based max so +/- works like normal products.
  if (
    $lineItem &&
    $lineItem.attr('data-is-gift-card') === 'true' &&
    typeof jscGiftCardRestrictionEnabled === 'function' &&
    !jscGiftCardRestrictionEnabled()
  ) {
    return NaN;
  }

  var maxFromInput = parseInt($input.attr('data-max'), 10);
  var maxFromDetails = parseInt($lineItem.find('.jsc-product-details-input').attr('data-max-qty'), 10);

  if (!isNaN(maxFromInput)) {
    return maxFromInput;
  }
  if (!isNaN(maxFromDetails)) {
    return maxFromDetails;
  }
  return NaN;
}

jscCommitCartDrawerQtyInput = ($input) => {
  var $lineItem = $input.closest('.jsc-cart-line-items');
  if (!$lineItem.length || !$input.length) {
    return;
  }

  // Only lock qty when the GC restriction feature is active.
  if (jscGiftCardRestrictionEnabled() && $lineItem.attr('data-is-gift-card') === 'true') {
    return;
  }

  var $vid = $lineItem.attr('data-var-id');
  if (!$vid) {
    return;
  }

  var count = parseInt($input.val(), 10);
  if (isNaN(count) || count < 1) {
    count = 1;
  }

  var maxQty = jscGetCartDrawerQtyMax($input, $lineItem);
  if (!isNaN(maxQty) && count > maxQty) {
    count = maxQty;
  }

  var committed = parseInt($input.attr('data-committed-qty'), 10);
  if (isNaN(committed)) {
    committed = parseInt($input.attr('value'), 10);
  }

  $input.val(count);
  $input.attr('value', count);
  jscSyncCartDrawerQtyControls($input, count, maxQty);

  if (!isNaN(committed) && count === committed) {
    return;
  }

  $input.attr('data-committed-qty', count);
  cartJSUpdateQuery($vid, count, {}, true);
}

$(document).on('change blur', '.jsc-cart-drawer-div .cart-item__quantity-input', function () {
  jscCommitCartDrawerQtyInput($(this));
});

$(document).on('keydown', '.jsc-cart-drawer-div .cart-item__quantity-input', function (e) {
  if (e.key === 'Enter' || e.keyCode === 13) {
    e.preventDefault();
    $(this).trigger('change');
  }
});

jscMinusItemCartDrawer = (e) => {
  var $input = $(e).parent().find('input');
  var $lineItem = $(e).parents('.jsc-cart-line-items');
  if (jscGiftCardRestrictionEnabled() && $lineItem.attr('data-is-gift-card') === 'true') {
    return;
  }
  var count = parseInt($input.val(), 10) - 1;
  var $maxQty = jscGetCartDrawerQtyMax($input, $lineItem);
  var $thisPlus = $(e).parent().find('.plus');
  count = count < 1 ? 1 : count;

  $input.val(count);
  $input.attr('value', count);
  $input.attr('data-committed-qty', count);
  jscSyncCartDrawerQtyControls($input, count, $maxQty);

  var $vid = $lineItem.attr('data-var-id');
  // Refresh only after CartJS succeeds — avoid immediate jscUpdateCartDrawer()
  // which can fetch stale /cart.js and briefly revert the optimistic qty.
  cartJSUpdateQuery($vid, count, {}, true);

  if ($input.val() < $maxQty) {
    $thisPlus.removeClass('unusable');
  }
}
jscPlusItemCartDrawer = (e) => {
  var $input = $(e).parent().find('input');
  var $lineItem = $(e).parents('.jsc-cart-line-items');
  if (jscGiftCardRestrictionEnabled() && $lineItem.attr('data-is-gift-card') === 'true') {
    return;
  }
  var $maxQty = jscGetCartDrawerQtyMax($input, $lineItem);
  var $inputValueInt = parseInt($input.val(), 10);

  if (isNaN($maxQty) || $inputValueInt < $maxQty) {
    var count = $inputValueInt + 1;
    $input.val(count);
    $input.attr('value', count);
    $input.attr('data-committed-qty', count);
    jscSyncCartDrawerQtyControls($input, count, $maxQty);

    var $vid = $lineItem.attr('data-var-id');
    // Refresh only after CartJS succeeds — same race fix as minus.
    cartJSUpdateQuery($vid, count, {}, true);
  }
}
jscRemoveItemCartDrawer = (e) => {
  var $lineItem = $(e).parents('.jsc-cart-line-items');
  var $vid = $lineItem.attr('data-var-id');
  var $isGwp = $lineItem.attr('data-gwp');

  if ($isGwp == 'true') {
    jscSetGwpOptOut($lineItem.attr('data-promo'));
  }

  cartJSUpdateQuery($vid, 0, {}, true);
  $lineItem.remove();
}
//end: side cart drawer

//start: calculate free gift GWP progress bar
calculateProgressGWP = (currentVal, targetVal) => {
  var freeGiftSection = $('.jsc-cart-freegift-section');
  var cartMinText = freeGiftSection.find('.cart-shipping__wrapper').attr('minprice-aud');
  var cartMinVal = parseInt(cartMinText);
  var progressBar = freeGiftSection.find('.cart-shippingThreshold__progress');
  var progressNum = freeGiftSection.find('.cart-shipping__num');
  var progressOuter = freeGiftSection.find('.cart-shipping__numOuter');
  var successMsg = freeGiftSection.find('.cart-shipping__success');
  var freeItemId = freeGiftSection.find('.cart-shipping__wrapper').attr('data-item-id');
  var isGwpInCart = false;

  if (freeGiftSection.length > 0) {
    $.when($.getJSON('/cart.js', function(cart) {
      var _totalPrice = cart.total_price;
      var $cartItems = cart.items;
      var blockGwpForGiftCard = jscShouldBlockGwpAutoAddForGiftCard(cart);

      for (var i = 0; i < $cartItems.length; i++) {
        var $itemID = $cartItems[i].id;
        var $itemGwpProp = $cartItems[i].properties['_Cart_GWP'];
        var $itemGwpPropPromo = $cartItems[i].properties['_Cart_Gift'];

        if (freeItemId == $itemID && $itemGwpProp == 'Free Gift' && $itemGwpPropPromo == 1) {
          isGwpInCart = true;
          
        }
      }
      console.log('isGwpInCart',isGwpInCart);
      
      if (_totalPrice > 0) {
        freeGiftSection.removeClass('d-none');
        var calcFreeDeliveryVal = (cartMinVal - _totalPrice) / 100;
        var progressWidth = Math.round(100 * _totalPrice / cartMinVal);
        if (progressWidth >= 100) {
          progressWidth = 100;
        }
        var progressWidthPercent = progressWidth.toString() + '%';
        //console.log('cart Total',_totalPrice,cartMinVal,progressWidth,progressWidthPercent);

        progressBar.each(function(){
          
          $(this).css({
            width: progressWidthPercent
          });
        });

        if (_totalPrice >= cartMinVal) {
          console.log('free gift');
          progressOuter.hide();
          successMsg.show();
          if (isGwpInCart == false && !blockGwpForGiftCard) {
            $('.jsc-cart-items-section').append('<input type="hidden" value="'+ freeItemId +'" class="jsc-cart-gift" data-promo="1">');
            cartGift();
            jscUpdateCartDrawer(freeItemId,isGwpInCart);
          } else {
            $('.jsc-cart-items-section .jsc-cart-gift').remove();
          }
          
        } else {
          console.log('still short from free gift',calcFreeDeliveryVal);
          progressNum.text(calcFreeDeliveryVal);
          progressOuter.show();
          successMsg.hide();
          if (isGwpInCart == true) {
            $('.jsc-cart-items-section').append('<input type="hidden" value="'+ freeItemId +'" class="jsc-cart-gift-remove jsc-promo-1">');
            //isGwpInCart = false;
            cartGift();
            jscUpdateCartDrawer(freeItemId,isGwpInCart);
          }
        }
      }
      else{
        //console.log('cart Total',_totalPrice);
        freeGiftSection.addClass('d-none');
      }
      
    })).then(function() {
    });
  }
};
jscUpdateShippingAndGWPbar = () => {
  setTimeout(function(){
    calculateProgress();
    calculateProgressGWP();
  },500);
}
//end: calculate free gift GWP progress bar